import { Chip, Typography } from '@material-ui/core';

// label IS TO SET TITLE FOR CHIP
// fn IS TO ADD ONCLICK FUNCTION
// variant IS SAME AS MUI CHIP
// sx IS FOR STYLE
// type TAKES 10, 20, 30 AS INPUT AND THEN USES getBgColor FUNCTION TO SET backgroundcolor FOR CHIP


export default function GlobalChip({ label, fn, variant, sx, type }) {

    const getBgColor = (type) => {
        let id = '#FFD4D5';

        switch (type) {
            case 10:
                id = '#FFD4D5' /* RED VARIANT */
                break;
            case 20:
                id = '#C5F7CB' /* GREEN VARIANT */
                break;

            default:
                id = '#FFEDB8' /* YELLOW VARIANT */
                break;
        }
        return id
    }
    return (<>
        <Chip
            onClick={fn}
            label={label}
            variant={variant || 'outlined'}
            sx={{
                border: 'none',
                cursor: 'pointer',
                fontWeight: 'bold',
                color: '#000000',
                backgroundColor: getBgColor(type),
                ...sx,
                "& .MuiChip-label": {
                    fontWeight: 'bold', fontSize: { sm: '10px', lg: '11px', xl: '14px' },
                },
                '&.MuiChip-root:hover': {   // Target the root element of the Chip
                    backgroundColor: getBgColor(type),
                    color: '#000000'
                }
            }}
        />
    </>)
}